const currency = {
  dollar: 0,
  euro: 1,
  pound: 2,
};

export { currency };
